// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {
  Row,
  Col,
  Carousel,
  CarouselItem,
  Loading,
  Select,
  Option,
  Message,
} from 'element-ui';
import App from './App'
import router from './router'

// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// // element-ui 用到响应式布局的话 要加载 display.css 样式
import 'element-ui/lib/theme-chalk/display.css';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import axios from 'axios'

import VueLazyload from 'vue-lazyload'


Vue.config.productionTip = false

Vue.use(Row);
Vue.use(Col);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Loading);
Vue.use(Select);
Vue.use(Option);

Vue.component(Message);
Vue.prototype.$message = Message

Vue.use(VueAwesomeSwiper);
Vue.prototype.$axios = axios
Vue.use(VueLazyload);


router.afterEach((transition) => {
  // 解决 vue 单页路由跳转后的scrollTop 问题
  window.scrollTo(0, 0)
});

router.beforeEach((to, from, next) => {

  // 改变页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 判断是否有渠道 全局url添加渠道
  if(to.query.q){
   next();
   return;
  }

  if(from.query.q){
    let toQuery = JSON.parse(JSON.stringify(to.query));
    toQuery.q = from.query.q;
    next({
      path:to.path,
      query:toQuery
    })
  }else{
    next();
  }
  
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js